import React from "react";
import { Link } from "react-router-dom";
import Nav from "./common/Nav";
import Footer from "./common/Footer";
import AboutImg from "./img/about-img.jpeg";

const About = () => {
    return (
        <div>
            <Nav />
            <section className="brdcrm">
                <h2>About</h2>
            </section>

            <section className="about_section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="img-box">
                                <img src={AboutImg} alt="" />
                            </div>
                        </div>
                        <div className="col-md-7">
                            <br />
                            <div className="detail-box">
                                <div className="heading_container">
                                    <h2> About <span>Us</span> </h2>
                                </div>
                                <p>Golden State Movers is your trusted partner for seamless and reliable moving services across California. Whether you're relocating your home, office, or business, we ensure a stress-free experience tailored to meet your unique needs. Our team of experienced professionals is dedicated to handling every aspect of your move with care, efficiency, and attention to detail.</p>
                                <p>At Golden State Movers, we specialize in local and long-distance moves, offering comprehensive solutions that include packing, loading, transportation, and unpacking. We take pride in our commitment to customer satisfaction, ensuring your belongings are treated with the utmost care from start to finish.</p>
                                <p>With modern equipment, competitive pricing, and a passion for excellence, Golden State Movers makes the moving process simple and worry-free. Trust us to provide personalized service that turns a daunting task into a smooth transition. Choose Golden State Movers – where every move is a golden opportunity for a fresh start!</p>
                                <Link to="/contact">Enquiry Now</Link>
                            </div>
                        </div>
                        <br />
                        <br />
                    </div>
                    <br />
                    <div className="row detail-box" style={{ padding: "20px 0", background: "aliceblue" }}>
                        <div className="col-lg-4">
                            <div className="heading_container">
                                <h2> Our <span>Mission</span> </h2>
                                <p><b>At Golden Movers, our mission is clear:</b></p>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <p>To transform your moving experience into a hassle-free journey. <br />
                                We’re committed to: <br />
                                - Providing reliable transitions. <br />
                                - Taking meticulous care of your belongings. <br />
                                - Offering exceptional service. <br />
                                With innovative solutions and a strong focus on customer satisfaction, <br />
                                we set the benchmark for moving excellence. <br />
                                Experience the Golden Movers difference today.</p>
                        </div>
                    </div>
                    <br />
                    <div className="row detail-box" style={{ padding: " 20px 0" }}>
                        <div className="col-lg-4">
                            <div className="heading_container">
                                <h2> Our <span>Vision</span> </h2>
                                <p><b>Golden Movers aspires to create a future:</b></p>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <p>A future where relocations are seamless, living environments shine with cleanliness, and home enhancements become works of art. Our mission is to be the preferred choice for exceptional services, redefining industry benchmarks. We are committed to excellence, fostering enduring connections through dependability and innovation.</p>
                        </div>
                    </div>
                    <br />
                    <div className="row detail-box" style={{ padding: " 20px 0", background: "aliceblue" }}>
                        <div className="col-lg-4">
                            <div className="heading_container">
                                <h2> Our <span>Principles</span> </h2>
                                <p><b>At Golden Movers, our principles guide everything we do:</b></p>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <p>– Customer-Focused: Delivering seamless and stress-free moving experiences.
                                – Integrity and Professionalism: Upholding honesty, transparency, and trustworthiness in every interaction.
                                – Commitment to Excellence: Providing top-tier quality in all moving, cleaning, and handyman services.</p>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default About;